import { api } from "api";
import { getRefetchInterval, useRefetchMeta } from "@vyne-shared/utils/invalidateQueriesFor";
import { useQuery } from "@tanstack/react-query";

/**
 * Client hook to obtain summary information for a given patient.
 * @param id The Payments ID of the patient to look up.
 * @returns React Query properties.
 */
export function usePatientSummaryQuery(id: number) {
    return useQuery({
        queryKey: ["summary", id],
        queryFn: async (context) => await api.provider.summary(id, context.signal),
        meta: useRefetchMeta(1000),
        refetchInterval: getRefetchInterval,
    });
}
